import rebeccaPic from "@/public/images/artists/rebecca.png";
import { Artist } from "@/types/types";

export const rebecca = {
  id: "201",
  name: "Rebecca",
  image: rebeccaPic,
  description: `Rebecca's voice is bold and vibrant with an unfiltered tone and a dynamic, playful delivery that blends confident cadence with a raw, rhythmic edge.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Frebecca-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["RnB", "Afrobeat", "Hip Hop"],
      secondary: ["Alluring"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 56,
        high: 72,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
